import { useEffect, useState } from 'react'
import Layout from './Layout'
import api from '../services/api'

export default function Configuracoes() {
  const [form, setForm] = useState({
    nome: '', municipio: '', estado: '', cnpj: '',
    telefone: '', email: '', site: '', endereco: '',
    logo_url: ''
  })
  const [sucesso, setSucesso] = useState('')
  const [erro, setErro] = useState('')
  const [load, setLoad] = useState(false)

  useEffect(() => { carregar() }, [])

  async function carregar() {
    try {
      const r = await api.get('/configuracoes')
      if (r.data) setForm(f => ({ ...f, ...r.data }))
    } catch {}
  }

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  async function salvar(e) {
    e.preventDefault()
    setErro(''); setLoad(true)
    try {
      await api.put('/configuracoes', form)
      setSucesso('Configurações salvas com sucesso!')
      setTimeout(() => setSucesso(''), 3000)
    } catch(e) {
      setErro(e.response?.data?.erro || 'Erro ao salvar')
    } finally { setLoad(false) }
  }

  const inp = (k, label, placeholder, tipo='text') => (
    <div>
      <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>{label}</label>
      <input
        type={tipo}
        value={form[k]||''}
        onChange={e => set(k, e.target.value)}
        placeholder={placeholder}
        style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }}
      />
    </div>
  )

  return (
    <Layout>
      <h1 style={{ fontSize:18, fontWeight:500, margin:'0 0 24px' }}>Configurações do órgão</h1>

      {sucesso && <div style={{ background:'#f0fdf4', border:'1px solid #bbf7d0', borderRadius:8, padding:12, fontSize:13, color:'#15803d', marginBottom:16 }}>{sucesso}</div>}
      {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, color:'#dc2626', marginBottom:16 }}>{erro}</div>}

      <form onSubmit={salvar}>
        <div style={{ display:'flex', flexDirection:'column', gap:16 }}>

          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:24 }}>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:16 }}>Dados do órgão</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
              <div style={{ gridColumn:'1/-1' }}>
                {inp('nome', 'Nome do órgão *', 'Prefeitura Municipal de...')}
              </div>
              {inp('municipio', 'Município', 'Nome da cidade')}
              {inp('estado', 'Estado (UF)', 'Ex: PI')}
              {inp('cnpj', 'CNPJ', '00.000.000/0000-00')}
              <div style={{ gridColumn:'1/-1' }}>
                {inp('endereco', 'Endereço', 'Rua, número, bairro, cidade')}
              </div>
            </div>
          </div>

          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:24 }}>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:16 }}>Contato</div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
              {inp('telefone', 'Telefone', '(00) 00000-0000')}
              {inp('email', 'E-mail institucional', 'contato@prefeitura.gov.br', 'email')}
              <div style={{ gridColumn:'1/-1' }}>
                {inp('site', 'Site', 'https://www.prefeitura.gov.br')}
              </div>
            </div>
          </div>

          <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:24 }}>
            <div style={{ fontSize:14, fontWeight:500, marginBottom:16 }}>Identidade visual</div>
            {inp('logo_url', 'URL do brasão / logotipo', 'https://...')}
            {form.logo_url && (
              <div style={{ marginTop:12 }}>
                <div style={{ fontSize:12, color:'#9ca3af', marginBottom:6 }}>Preview:</div>
                <img src={form.logo_url} alt="Logo" style={{ height:60, objectFit:'contain', border:'1px solid #e5e7eb', borderRadius:8, padding:6 }}
                  onError={e => e.target.style.display='none'} />
              </div>
            )}
          </div>

          <div style={{ display:'flex', justifyContent:'flex-end' }}>
            <button type="submit" disabled={load}
              style={{ padding:'10px 24px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:14, cursor:'pointer', fontWeight:500 }}>
              {load ? 'Salvando...' : 'Salvar configurações'}
            </button>
          </div>
        </div>
      </form>
    </Layout>
  )
}
